import { ModuleName } from '../const/moduleName';

export const isProduction = process.env.NODE_ENV === 'production';
export const isSandbox = false;
export const generalClasses = {
	fixedSection: 'fixed-section',
};
export const fixedSectionClass = 'fixedSection';
export const pageMainClass = 'app__body';
export const pageSidebarExpandedClass = 'app__body--sidebar-expanded';
export const pageMainSidebarTransitionedClass = 'app__body--sidebar-and-tool-navigation-transitioned';
export const pageMainToolNavigationTransitionedClass = 'app__body--tool-navigation-transitioned';

export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const PENDING = 'PENDING';

export enum ThemeStyle {
	Dark = 'dark',
	Light = 'light',
}

export const STATUS_LABEL_ENUM = {
	NO_ICON: 0,
	CHECK_MARK_GREEN: 1,
	EXCLAMATION_PINK: 2,
	SAND_CLOCK_YELLOW: 3,
	CRISS_CROSS_RED: 4,
	EXCLAMATION_YELLOW: 5,
	EXCLAMATION_BLUE: 6,
	INFO_BLUE: 7,
	ICON_BAN: 8,
	ICON_HISTORICAL: 9,
	RECYCLE_BIN_RED: 10,
};

export const COPYRIGHT_UNICODE = '\u00A9';

export const entityTypeIds = {
	EMPLOYER: 18,
	AGENCY: 20,
	CANDIDATE: 95,
	COMMUNITY: 283,
	PLATFORM_USER: 2,
	SUPPLIER: 909,
};

export const oldModuleOnNewRouteClass = 'react-old-module-on-new-route';
export const oldErrorPageClass = 'error-page';
export const USER_LOGIN_PATH = '/user/login';
export const MODULE_PATHS = {
	activityList: '/activity/list',
	activityTaskList: '/activity/tasklist',
	agencyCommonDetails: '/agency/commondetails',
	agencyList: '/agency/list',
	allJobs: '/publicJob/allJobs',
	apiUserCommonDetails: '/apiuser/commondetails',
	apiUserList: '/apiuser/List',
	applicationForm: '/application/form',
	applicationsCommonDetails: '/application/commondetails',
	applicationsList: '/application/list',
	auditTrailList: '/audittrail/list',
	automationDetails: '/automation/commonDetails',
	automationList: '/automation/list',
	automationLogList: '/automation/logList',
	calculationSchemeDetails: '/calculationscheme/commondetails',
	calculationSchemeList: '/calculationscheme/list',
	candidateChangeList: '/candidatechange/list',
	candidateCommonDetailsNew: '/candidate/commondetails',
	candidateList: '/candidate/list',
	candidatePensionList: '/candidatepension/list',
	candidateStatusMappingList: '/candidatestatusmapping/list',
	caoDetails: '/cao/commondetails',
	caoInstanceDetails: '/caoInstance/commondetails',
	caoList: '/cao/list',
	caoListInstance: '/caoinstance/list',
	caoNewsDetail: '/caonews/commondetails',
	caoNewsList: '/caonews/list',
	caoWagesList: '/caowages/list',
	caoWagesRequestDetails: '/caowagesrequest/commondetails',
	caoWagesRequestList: '/caowagesrequest/list',
	clockwiseCompactView: '/timecard/commoncompact',
	clockwiseDetail: '/timecard/commondetails',
	clockwiseList: '/timecard/list',
	commentsList: '/comments/list',
	communitiesCommonDetails: '/community/commondetails',
	communitiesList: '/community/list',
	componentModelDetail: '/componentmodel/commondetails',
	componentModelList: '/componentmodel/list',
	connectDashboardList: '/connectdashboard/list',
	connectSettings: '/connect/Settings',
	connectorDetail: '/plugin/commondetails',
	connectorList: '/plugin/list',
	contactPersonDetail: '/employer/contactpersoncommondetails',
	contactPersonList: '/employer/contactpersonlist',
	contractCommonDetails: '/contract/commondetails',
	contractsList: '/contract/list',
	contractsUpdateDetail: '/contract/bulkupdaterequestcommondetails',
	contractsUpdateList: '/contract/bulkupdaterequestlist',
	customCaoDetails: '/customcao/commondetails',
	customCaoInstanceDetails: '/customcaoinstance/commondetails',
	customCaoInstanceList: '/customcaoinstance/list',
	customCaoList: '/customcao/list',
	customerDetails: '/customer/commondetails',
	customerInvoiceComponentList: '/customerInvoiceComponent/list',
	customerInvoiceDetails: '/customerinvoice/commondetails',
	customerInvoiceList: '/customerinvoice/list',
	customerList: '/customer/list',
	customerSubscriptionsDetails: '/customerSubscriptions/commondetails',
	customerSubscriptionsList: '/customerSubscriptions/list',
	dashboard: '/dashboard/index',
	dealsCommonDetails: '/deal/commondetails',
	dealsList: '/deal/list',
	documentList: '/document/list',
	documentSettingsDetail: '/document/documentsettingcommondetails',
	documentSettingsList: '/document/documentsettinglist',
	documentTemplateDetails: '/documenttemplate/commondetails',
	documentTemplateList: '/documenttemplate/list',
	domainValueDetail: '/domainvalue/commondetails',
	domainValueList: '/domainvalue/list',
	domainValueMappingList: '/domainValue/mapping',
	domainValueCaoMappingList: '/domainValue/caoMapping',
	emailSenderAuthCommonDetails: '/emailsenderauth/commondetails',
	emailSenderAuthList: '/emailsenderauth/list',
	employerCommonDetails: '/employer/commondetails',
	employerList: '/employer/list',
	fixedBreakList: '/fixedBreak/list',
	flexNetCustomerDetail: '/flexnetcustomer/commondetails',
	flexNetCustomerList: '/flexnetcustomer/list',
	flexNetHostDetail: '/flexnethost/commondetails',
	flexNetHostList: '/flexnethost/list',
	flexNetHostSettingsDetail: '/flexnethost/settings',
	formCommonDetails: '/form/commondetails',
	formDesignerDetail: '/formdesigner/details',
	formDesignerList: '/formdesigner/list',
	formList: '/form/list',
	formPublic: '/form/public',
	formPublicViaLink: '/form/publicvialink',
	fsApiLogList: '/fsapilog/list',
	illnessCommonDetails: '/illness/commondetails',
	illnessList: '/illness/list',
	incomingMessage: '/incomingmessage/commonDetails',
	incomingMessageList: '/incomingmessage/List',
	incomingMessageLogList: '/incomingmessage/LogList',
	invoiceList: '/invoice/list',
	issueDetail: '/contact-us',
	jobBoardDetails: '/jobboard/commondetails',
	jobBoardInstanceDetail: '/jobBoardInstance/commondetails',
	jobBoardInstanceList: '/jobboardinstance/list',
	jobBoardList: '/jobboard/list',
	jobCommonDetails: '/job/commondetails',
	jobList: '/job/list',
	jobPostDetail: '/jobpost/commondetails',
	jobPostList: '/jobpost/List',
	labelDetails: '/label/commonDetails',
	labelList: '/label/list',
	modelMatrixDetail: '/modelmatrix/commondetails',
	modelMatrixInstanceDetail: '/modelmatrixinstance/commondetails',
	modelMatrixInstanceList: '/modelmatrixinstance/list',
	modelMatrixList: '/modelmatrix/list',
	newsAdminCommonDetails: '/newsadmin/commondetails',
	newsCommonDetails: '/news/commondetails',
	newsList: '/news/list',
	newsadminList: '/newsadmin/list',
	optOutList: '/surveyadmin/listoptout',
	outgoingMessageDetails: '/outgoingmessage/commonDetails',
	outgoingMessageList: '/outgoingmessage/list',
	outgoingMessageLogList: '/outgoingmessage/LogList',
	pageDetails: '/page/commonDetails',
	pageList: '/page/list',
	paymentList: '/payment/list',
	payslipList: '/payslip/list',
	payslipsCommonDetails: '/payslip/commondetails',
	periodicComponentsList: '/candidateperiodiccomponent/list',
	phaseList: '/candidatephase/list',
	playground: '/playground',
	proformaDetails: '/proforma/commondetails',
	proformaList: '/proforma/list',
	publicDocumentAuthentication: '/document/PublicDocumentLogIn',
	publicDocumentList: '/document/PublicDocumentList',
	publicEmployerDetail: '/publicEmployer/commondetails',
	publicEmployerList: '/publicEmployer/list',
	publicJobApply: '/publicJob/apply',
	publicJobDetail: '/publicJob/details',
	publicJobList: '/publicJob/list',
	publicNewsDetail: '/publicNews/commondetails',
	publicNewsList: '/publicNews/list',
	purchaseInvoiceList: '/purchaseinvoice/list',
	rateClassDetail: '/rateclass/commondetails',
	rateClassList: '/rateclass/list',
	reservationList: '/candidatereservation/list',
	rolesCommonDetails: '/role/commondetails',
	rolesList: '/role/list',
	safetyList: '/safety/list',
	savedFilterAdminList: '/savedfilter/SystemList',
	savedFilterLogsList: '/savedfilter/logsList',
	savedFilterMyList: '/savedfilter/MyList',
	savedFilterOwnList: '/savedfilter/OtherList',
	settingList: '/setting/list',
	shareLogDetail: '/sharelog/details',
	shareLogList: '/sharelog/list',
	structure: '/agency/commonStructure',
	subscriberList: '/subscriber/list',
	subscriptionSettingDetails: '/subscriptionSetting/commondetails',
	subscriptionSettingList: '/subscriptionSetting/list',
	suppliersList: '/supplierorganization/list',
	supportAccessList: '/customeraccessrequest/list',
	surveyAdminDetails: '/surveyadmin/commondetails',
	surveyAdminList: '/surveyadmin/list',
	surveyCommonDetails: '/survey/commondetails',
	surveyList: '/survey/list',
	surveyPublic: '/survey/public',
	surveyOptOut: '/survey/optout',
	tagList: '/tag/list',
	templateDetails: '/template/details',
	templateList: '/template/list',
	testCalculationScheme: '/calculationscheme/commonclockwisetest',
	textModelDetails: '/textmodel/commondetails',
	textModelList: '/textmodel/list',
	translationDetails: '/translation/commondetails',
	translationList: '/translation/list',
	uiKit: '/uiKit',
	userCommonDetails: '/user/commondetails',
	userProfile: '/user/profile',
	wmlDetails: '/wml/details',
	wmlList: '/wml/list',
	userList: '/user/list',
	backofficeActionPage: '/backoffice/index',
	backofficePaymentTransferFilesList: '/backofficePaymentTransferFiles/List',
	authentication: '/user/login',
	home: '/',
	managementInformation: '/managementInformation/Index',
	backofficeProcessingList: '/backofficeProcessing/list',
	journalTransferFilesList: '/backofficeJournalTransferFiles/list',
};

export const CONDITION_MODULE_PATHS: Record<string, string> = {};

export const NEW_MODULE_PATHS = [
	...Object.values(MODULE_PATHS),
	'/user/profile',
	'/user/login',
	'/agency/commonstructure',
	'/document/publicdocumentlist',
];

export const PUBLIC_CUSTOM_PAGE_PATH = {
	home: '/',
	error: '/error',
	maintenance: '/error/maintenance',
	securityStatement: '/security-statement',
	termsOfUse: '/terms-of-use',
	cookiePolicy: '/cookie-policy',
	privacyStatement: '/privacy-statement',
	aboutUs: '/about-us',
	cvdPolicy: '/cvd-policy',
} as const;

export const pageTypeIdsMatching = [
	[35, 36], // wml
	[37, 54], // timeCards
	[39, 40], // caoNews
	[43, 44], // employer
	[52, 906], // illness cases
	[76, 77], // contracts
	[79, 92], // cao`s
	[78], // document
	[80, 81], //agency
	[84, 85], // candidate
	[99, 100], // user
	[134], // reservations
	[135, 136], // caoWagesRequest
	[188], // candidate change
	[200, 46], // payslips
	[208, 209], // roles
	[213, 216], // incomingMessage (connect -> received)
	[214, 217], // outgoingMessage (connect -> sent)
	[284, 285], // community
	[354, 909], // translation
	[368, 369], // document template
	[370, 371], // emailSenderAuth
	[904, 905], // deals
	[886, 889], // calculationSchemes
	[506, 865], //jobPost
	[919, 912], //assessments
	[896, 897], //formDesigner
];

export enum ModuleTitleCodes {
	agency = 3157,
	agencyStructure = 4434,
	application = 4120,
	applicationForm = 202,
	auditrail = 380,
	auditrailSettings = 8902,
	calculationScheme = 9479,
	candidate = 14,
	candidateForm = 6015,
	candidateChange = 5156,
	candidatePensions = 10201,
	candidatePhase = 3388,
	candidateReservation = 3162,
	cao = 1773,
	caoCustomAgreement = 13947,
	caoInstance = 12379,
	caoNews = 1694,
	caoWages = 6204,
	caoWagesRequest = 6215,
	comment = 5409,
	community = 8001,
	componentModel = 5495,
	connectIncomingMessage = 2463,
	connectIncomingMessageLog = 821,
	connectOutgoingMessage = 2464,
	connectOutgoingMessageLog = 822,
	connectSettings = 738,
	connectEmailSenderAuth = 10403,
	connectAPIUser = 9202,
	connectFsAPILog = 5222,
	connectDashboard = 9229,
	contract = 316,
	customer = 785,
	customerInvoiceComponent = 3590,
	customerInvoice = 8861,
	customerSubscriptions = 9301,
	customerSubscriptionSetting = 2185,
	dashboard = 314,
	document = 318,
	documentSettings = 772,
	documentTemplate = 6441,
	domainValue = 7100,
	domainValueMapping = 3224,
	domainValueCaoMapping = 5259,
	employer = 6,
	employer1 = 4495,
	employer11 = 10588,
	flexnet = 4333,
	flexnet1 = 4372,
	flexnet11 = 738,
	formDesigner = 7612,
	forms = 7631,
	illness = 3431,
	invoice = 3009,
	job = 1397,
	label = 5429,
	label1 = 332,
	label11 = 1363,
	label111 = 257,
	modelMatrix = 8101,
	modelMatrix1 = 200,
	news = 1444,
	newsAdmin = 1444,
	payment = 3413,
	payslip = 3045,
	periodicComponents = 10680,
	rateclass = 6800,
	role = 2,
	savedfilter = 1125,
	savedfilter1 = 1126,
	savedfilter11 = 1127,
	savedfilter111 = 1131,
	share = 9018,
	share1 = 9019,
	share11 = 9005,
	share111 = 7196,
	survey = 7070,
	surveyAdmin = 7070,
	surveyAdmin1 = 7443,
	tag = 2399,
	task = 8882,
	task1 = 8655,
	textModel = 693,
	timecard = 705,
	user = 4,
	user1 = 179,
	wml = 1605,
}

export const MODULE_NINJA = [
	{
		titleCode: 314,
		moduleName: ModuleName.Dashboard,
		pageTypeId: 71,
	},
	{
		titleCode: ModuleTitleCodes.agency,
		moduleName: ModuleName.Agency,
		pageTypeId: 80,
	},
	{
		titleCode: ModuleTitleCodes.agencyStructure,
		moduleName: ModuleName.Agency,
		pageTypeId: 170,
	},
	{
		titleCode: 6,
		moduleName: ModuleName.Employer,
		pageTypeId: 43,
	},
	{
		titleCode: 4495,
		moduleName: ModuleName.Employer,
		pageTypeId: 185,
	},
	{
		titleCode: 10588,
		moduleName: ModuleName.Employer,
		pageTypeId: 904,
	},
	{
		titleCode: ModuleTitleCodes.candidate,
		moduleName: ModuleName.Candidate,
		pageTypeId: 84,
	},
	{
		titleCode: ModuleTitleCodes.candidateForm,
		moduleName: ModuleName.Candidate,
		pageTypeId: 349,
	},
	{
		titleCode: ModuleTitleCodes.candidateChange,
		moduleName: ModuleName.Candidate,
		pageTypeId: 188,
	},
	{
		titleCode: 10680,
		moduleName: ModuleName.PeriodicComponents,
		pageTypeId: 907,
	},
	{
		titleCode: 316,
		moduleName: ModuleName.Contract,
		pageTypeId: 76,
	},
	{
		titleCode: ModuleTitleCodes.document,
		moduleName: ModuleName.Document,
		pageTypeId: 78,
	},
	{
		titleCode: ModuleTitleCodes.documentSettings,
		moduleName: ModuleName.Document,
		pageTypeId: 268,
	},
	{
		titleCode: 705,
		moduleName: ModuleName.Timecard,
		pageTypeId: 37,
	},
	{
		titleCode: 3009,
		moduleName: ModuleName.Invoice,
		pageTypeId: 832,
	},
	{
		titleCode: 3045,
		moduleName: ModuleName.Payslip,
		pageTypeId: 200,
	},
	{
		titleCode: 3388,
		moduleName: ModuleName.CandidatePhase,
		pageTypeId: 151,
	},
	{
		titleCode: 3431,
		moduleName: ModuleName.Illness,
		pageTypeId: 52,
	},
	{
		titleCode: 3162,
		moduleName: ModuleName.CandidateReservation,
		pageTypeId: 134,
	},
	{
		titleCode: 3413,
		moduleName: ModuleName.Payment,
		pageTypeId: 270,
	},
	{
		titleCode: 1444,
		moduleName: ModuleName.News,
		pageTypeId: 62,
	},
	{
		titleCode: 5409,
		moduleName: ModuleName.Comment,
		pageTypeId: 401,
	},
	{
		titleCode: 8001,
		moduleName: ModuleName.Community,
		pageTypeId: 284,
	},
	{
		titleCode: 1397,
		moduleName: ModuleName.Job,
		pageTypeId: 193,
	},
	{
		titleCode: 8882,
		moduleName: ModuleName.Task,
		pageTypeId: 849,
	},
	{
		titleCode: 8655,
		moduleName: ModuleName.Task,
		pageTypeId: 866,
	},
	{
		titleCode: 1694,
		moduleName: ModuleName.CaoNews,
		pageTypeId: 39,
	},
	{
		titleCode: ModuleTitleCodes.cao,
		moduleName: ModuleName.Cao,
		pageTypeId: 75,
	},
	{
		titleCode: ModuleTitleCodes.caoCustomAgreement,
		moduleName: ModuleName.CaoCustomAgreement,
		pageTypeId: 920,
	},
	{
		titleCode: ModuleTitleCodes.caoInstance,
		moduleName: ModuleName.CaoInstance,
		pageTypeId: 79,
	},
	{
		titleCode: 6204,
		moduleName: ModuleName.CaoWages,
		pageTypeId: 119,
	},
	{
		titleCode: 6215,
		moduleName: ModuleName.CaoWagesRequest,
		pageTypeId: 135,
	},
	{
		titleCode: 1605,
		moduleName: ModuleName.Wml,
		pageTypeId: 35,
	},
	{
		titleCode: ModuleTitleCodes.application,
		moduleName: ModuleName.Application,
		pageTypeId: 308,
	},
	{
		titleCode: ModuleTitleCodes.applicationForm,
		moduleName: ModuleName.Application,
		pageTypeId: 311,
	},
	{
		titleCode: 9018,
		moduleName: ModuleName.Share,
		pageTypeId: 459,
	},
	{
		titleCode: 9019,
		moduleName: ModuleName.Share,
		pageTypeId: 465,
	},
	{
		titleCode: 9005,
		moduleName: ModuleName.Share,
		pageTypeId: 878,
	},
	{
		titleCode: 7196,
		moduleName: ModuleName.Share,
		pageTypeId: 506,
	},
	{
		titleCode: 7070,
		moduleName: ModuleName.Survey,
		pageTypeId: 402,
	},
	{
		titleCode: 7631,
		moduleName: ModuleName.Forms,
		pageTypeId: 898,
	},
	{
		titleCode: 4,
		moduleName: ModuleName.User,
		pageTypeId: 99,
	},
	{
		titleCode: 179,
		moduleName: ModuleName.User,
		pageTypeId: 59,
	},
	{
		titleCode: 2,
		moduleName: ModuleName.Role,
		pageTypeId: 208,
	},
	{
		titleCode: ModuleTitleCodes.connectIncomingMessage,
		moduleName: ModuleName.Connect,
		pageTypeId: 213,
	},
	{
		titleCode: ModuleTitleCodes.connectIncomingMessageLog,
		moduleName: ModuleName.Connect,
		pageTypeId: 202,
	},
	{
		titleCode: ModuleTitleCodes.connectOutgoingMessage,
		moduleName: ModuleName.Connect,
		pageTypeId: 214,
	},
	{
		titleCode: ModuleTitleCodes.connectOutgoingMessageLog,
		moduleName: ModuleName.Connect,
		pageTypeId: 206,
	},
	{
		titleCode: ModuleTitleCodes.connectSettings,
		moduleName: ModuleName.Connect,
		pageTypeId: 215,
	},
	{
		titleCode: ModuleTitleCodes.connectEmailSenderAuth,
		moduleName: ModuleName.Connect,
		pageTypeId: 370,
	},
	{
		titleCode: ModuleTitleCodes.connectAPIUser,
		moduleName: ModuleName.Connect,
		pageTypeId: 31,
	},
	{
		titleCode: ModuleTitleCodes.connectFsAPILog,
		moduleName: ModuleName.Connect,
		pageTypeId: 323,
	},
	{
		titleCode: ModuleTitleCodes.connectDashboard,
		moduleName: ModuleName.Connect,
		pageTypeId: 277,
	},
	{
		titleCode: ModuleTitleCodes.customer,
		moduleName: ModuleName.Customer,
		pageTypeId: 225,
	},
	{
		titleCode: ModuleTitleCodes.customerInvoiceComponent,
		moduleName: ModuleName.Customer,
		pageTypeId: 273,
	},
	{
		titleCode: ModuleTitleCodes.customerInvoice,
		moduleName: ModuleName.Customer,
		pageTypeId: 862,
	},
	{
		titleCode: ModuleTitleCodes.customerSubscriptions,
		moduleName: ModuleName.Customer,
		pageTypeId: 855,
	},
	{
		titleCode: ModuleTitleCodes.customerSubscriptionSetting,
		moduleName: ModuleName.Customer,
		pageTypeId: 176,
	},
	{
		titleCode: 5429,
		moduleName: ModuleName.Label,
		pageTypeId: 413,
	},
	{
		titleCode: 332,
		moduleName: ModuleName.Label,
		pageTypeId: 354,
	},
	{
		titleCode: 1363,
		moduleName: ModuleName.Label,
		pageTypeId: 57,
	},
	{
		titleCode: 257,
		moduleName: ModuleName.Label,
		pageTypeId: 890,
	},
	{
		titleCode: 2399,
		moduleName: ModuleName.Tag,
		pageTypeId: 357,
	},
	{
		titleCode: 1444,
		moduleName: ModuleName.NewsAdmin,
		pageTypeId: 64,
	},
	{
		titleCode: 1125,
		moduleName: ModuleName.SavedFilter,
		pageTypeId: 451,
	},
	{
		titleCode: 1126,
		moduleName: ModuleName.SavedFilter,
		pageTypeId: 452,
	},
	{
		titleCode: 1127,
		moduleName: ModuleName.SavedFilter,
		pageTypeId: 450,
	},
	{
		titleCode: 1131,
		moduleName: ModuleName.SavedFilter,
		pageTypeId: 453,
	},
	{
		titleCode: 6800,
		moduleName: ModuleName.RateClass,
		pageTypeId: 298,
	},
	{
		titleCode: 9479,
		moduleName: ModuleName.CalculationScheme,
		pageTypeId: 886,
	},
	{
		titleCode: ModuleTitleCodes.domainValue,
		moduleName: ModuleName.DomainValue,
		pageTypeId: 310,
	},
	{
		titleCode: ModuleTitleCodes.domainValueMapping,
		moduleName: ModuleName.DomainValue,
		pageTypeId: 396,
	},
	{
		titleCode: ModuleTitleCodes.domainValueCaoMapping,
		moduleName: ModuleName.DomainValue,
		pageTypeId: 353,
	},
	{
		titleCode: 8101,
		moduleName: ModuleName.ModelMatrix,
		pageTypeId: 445,
	},
	{
		titleCode: 200,
		moduleName: ModuleName.ModelMatrix,
		pageTypeId: 102,
	},
	{
		titleCode: 5495,
		moduleName: ModuleName.ComponentModel,
		pageTypeId: 486,
	},
	{
		titleCode: 6441,
		moduleName: ModuleName.DocumentTemplate,
		pageTypeId: 368,
	},
	{
		titleCode: 693,
		moduleName: ModuleName.TextModel,
		pageTypeId: 495,
	},
	{
		titleCode: ModuleTitleCodes.auditrail,
		moduleName: ModuleName.AuditTrail,
		pageTypeId: 244,
	},
	{
		titleCode: ModuleTitleCodes.auditrailSettings,
		moduleName: ModuleName.AuditTrail,
		pageTypeId: 104,
	},
	{
		titleCode: 7070,
		moduleName: ModuleName.SurveyAdmin,
		pageTypeId: 871,
	},
	{
		titleCode: 7443,
		moduleName: ModuleName.SurveyAdmin,
		pageTypeId: 425,
	},
	{
		titleCode: 4333,
		moduleName: ModuleName.FlexNet,
		pageTypeId: 297,
	},
	{
		titleCode: 4372,
		moduleName: ModuleName.FlexNet,
		pageTypeId: 301,
	},
	{
		titleCode: 738,
		moduleName: ModuleName.FlexNet,
		pageTypeId: 422,
	},
	{
		titleCode: ModuleTitleCodes.formDesigner,
		moduleName: ModuleName.FormDesigner,
		pageTypeId: 896,
	},
	{
		titleCode: 10201,
		moduleName: ModuleName.CandidatePensions,
		pageTypeId: 902,
	},
	{
		titleCode: 12369,
		moduleName: ModuleName.Proforma,
		pageTypeId: 913,
	},
	{
		titleCode: 13201,
		moduleName: ModuleName.Automation,
		pageTypeId: 917,
	},
	{
		titleCode: 14377,
		moduleName: ModuleName.Connector,
		pageTypeId: 930,
	},
];
